var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 48,
    viewBox: "0 0 54 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1373_92)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1373_92",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 0H0V48H54V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1373_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3142 23.0302C48.2033 20.5217 47.6488 18.0886 46.674 15.789C45.6057 13.2746 44.0764 11.0215 42.1268 9.08202C40.1771 7.14251 37.9123 5.6211 35.3848 4.55843C32.7697 3.46092 29.9971 2.90346 27.131 2.90346C24.2649 2.90346 21.4922 3.46092 18.8772 4.55843C16.3497 5.6211 14.0848 7.14251 12.1352 9.08202C11.7733 9.44205 11.4289 9.80789 11.0962 10.1911L8.15425 9.17493C12.573 3.58868 19.4317 0 27.131 0C40.4515 0 51.2562 10.7428 51.2562 24V24.0465L48.3142 23.0302ZM5.94779 25.1091C6.07621 27.5654 6.62491 29.9521 7.58221 32.211C8.65042 34.7254 10.1797 36.9785 12.1294 38.918C14.079 40.8575 16.3438 42.3789 18.8713 43.4416C21.4864 44.5391 24.2591 45.0965 27.1251 45.0965C29.9912 45.0965 32.7639 44.5391 35.379 43.4416C37.9065 42.3789 40.1713 40.8575 42.1209 38.918C42.477 38.5638 42.8214 38.1979 43.1483 37.8205L46.0961 38.8251C41.6773 44.4113 34.8244 48 27.1251 48C13.8338 48 3.05254 37.3095 3 24.0987L5.94779 25.1091Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12355 27.0081L4.55886 21.2012L0 27.0081H9.12355ZM54 21.2012L49.4003 27.0081L44.7889 21.2012H54Z",
    fill: "#999999"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1373_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceen2);
export default __webpack_public_path__ + "static/media/balanceen2.1a31e411e284d523e64a538f5f25ea81.svg";
export { ForwardRef as ReactComponent };